import { useEffect } from "react";
import InviteCom from "../../../components/InviteCom/InviteCom";
import { useDispatch } from 'react-redux';
import { setTopNavbar } from '../../../Reducers/actions/navbarActions';
import useSocialNetworksPrompt from '../../../hooks/useSocialNetworksPrompt';
import SocialNetworksPrompt from '../../../components/SocialNetworksPrompt/SocialNetworksPrompt';

const InviteCommunity = () => {
    const dispatch = useDispatch();
    
    // Social networks prompt modal (invite screen opened trigger - once per day)
    const socialNetworksPrompt = useSocialNetworksPrompt('invite');
    
    useEffect(() => {
        dispatch(setTopNavbar({
          title: 'Invite Community',
          back: true,
        }))
      }, []);
    return (
        <div >
            {socialNetworksPrompt.isOpen && (
                <SocialNetworksPrompt 
                    open={socialNetworksPrompt.isOpen} 
                    onClose={socialNetworksPrompt.closeModal} 
                />
            )}
            <div className="d-flex f-column aic p-24 pt-40">
                <InviteCom />
            </div>
        </div>
    )
}

export default InviteCommunity